import ABSService from "./absService";

class HenQuayLaiService extends ABSService {
    constructor() {
        super("henquaylai");
    }
}

export default HenQuayLaiService;